export function calculatePagination(
  page: number,
  itemPerPage: number,
): { limit: number; offset: number } {
  return {
    limit: itemPerPage,
    offset: (page - 1) * itemPerPage,
  };
}
